import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

const fetchMessages = async (type) => {
  const fetchFn =
    type === "email" ? api.messages.fetchAllEmails : api.messages.fetchAllSms;

  const data = await fetchFn();
  return data;
};
const useMessages = (type) => {
  const { data: messages, ...queryResponse } = useQuery({
    queryKey: ["sent-messages", type],
    queryFn: () => fetchMessages(type),
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { messages, fetchState };
};

const useMessage = (messageId) => {
  const { data: message, ...queryResponse } = useQuery({
    queryKey: ["selected-message", messageId],
    queryFn: () => api.messages.fetchMessage(messageId),
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { message, fetchState };
};

const useMessageBalance = () => {
  const { data, ...queryResponse } = useQuery({
    queryKey: ["message-balance"],
    queryFn: api.messages.fetchBalance,
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { balance: data, fetchState };
};

const useSendMessage = () => {
  const { mutateAsync, ...queryResponse } = useMutation({
    queryKey: ["send-message"],
    mutationFn: (payload) => api.messages.sendMessageCampaign(payload),
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { send: mutateAsync, fetchState };
};

export { useMessages, useMessage, useMessageBalance, useSendMessage };
